module.exports = __webpack_public_path__ + "media/media/logos/crystler-logo-d22c965943ae17d43ec1477884829911.png";